import render from './render';
import { setState } from "./state";
export default function mount(parent, child, selector) {
    if (Array.isArray(child)) {
        _mountAll(parent, child, selector);
    }
    else {
        _mount(parent, child, selector);
    }
}
function _mount(parent, child, selector) {
    if (child instanceof Mountable) {
        selector = child.useParentSelector ? parent.kompo.selector : child.selector;
        if (selector) {
            setState(child.Element, selector);
        }
        child = child.Element;
    }
    else if (selector) {
        setState(child, selector);
    }
    render(child);
    // Protection if same element is appended multiple times
    const mounts = parent.kompo.mounts;
    if (mounts.indexOf(child) === -1) {
        child.kompo.unmount = () => {
            mounts.splice(mounts.indexOf(child), 1);
        };
        mounts.push(child);
    }
}
function _mountAll(parent, children, selector) {
    // Mount all children ...
    for (let i = 0, l = children.length; i < l; ++i) {
        _mount(parent, children[i], selector);
    }
}
export function unmount(Element) {
    if (Element.kompo.unmount) {
        Element.kompo.unmount();
    }
}
export function unmountAll(Element) {
    Element.kompo.mounts = [];
}
export function mountIndex(parent, child) {
    return parent.kompo.mounts.indexOf(child);
}
export function getMounts(Element) {
    return Element.kompo.mounts;
}
export class Mountable {
    constructor(Element, selector, useParentSelector) {
        this.Element = Element;
        this.selector = selector;
        if (!this.selector) {
            this.useParentSelector = true;
        }
        else {
            this.useParentSelector = typeof (useParentSelector) !== 'undefined' ? useParentSelector : false;
        }
    }
}
export function mountable(Element, selector, useParentSelector) {
    return new Mountable(Element, selector, useParentSelector);
}
//# sourceMappingURL=mount.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/component/mount.js
// module id = 3
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11